"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _logger = require("@/services/logger/logger.service");

var _helper = require("@/services/helper/helper.service");

var _request = require("@/services/request/request.service");

var logger = new _logger.Logger();
var helper = new _helper.Helper();
var actions = {
  setDateRange: function setDateRange(_ref, payload) {
    var commit = _ref.commit;
    commit('SET_START_DATE', payload['startDate']);
    commit('SET_END_DATE', payload['endDate']);
  },
  loadCoreInformation: function loadCoreInformation(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state,
        rootState = _ref2.rootState,
        dispatch = _ref2.dispatch;
    var lfToken = rootState['authentication']['lfToken'];
    var requestAuth = new _request.Request('application/json', lfToken);
    return requestAuth.getAll([requestAuth.getFullPath('LEGACY_CORE', "setting?type=".concat(process.env.VUE_APP_RAILWAY_COLUMN_KEY))]).then(function (data) {
      commit('SET_CORE_INFORMATION', data);
      return true;
    }).catch(function () {
      return false;
    });
  },
  getUnassignedOrders: function () {
    var _getUnassignedOrders = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
      var commit, state, rootState, orderAPI, res, data, pagination, dataPagination;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref3.commit, state = _ref3.state, rootState = _ref3.rootState;
              commit('SET_TABLE_LOADING', true);
              orderAPI = helper.getOrderAPI(rootState);
              _context.next = 5;
              return orderAPI.getUnassignedOrders(state, 'railway');

            case 5:
              res = _context.sent;

              if (!(!res || res.failed)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", false);

            case 8:
              data = res && res['data'] ? res['data'] : [];
              commit('SET_UNASSIGNED_ORDERS', data); // Set Pagination

              pagination = helper.cloneDeep(state['pagination']);
              dataPagination = helper.get(res, 'pagination', null);
              pagination['currentPage'] = dataPagination.currentPage;
              pagination['totalData'] = dataPagination.totalData;
              commit('SET_PAGINATION', pagination);
              commit('SET_TABLE_LOADING', false);
              return _context.abrupt("return", true);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getUnassignedOrders(_x) {
      return _getUnassignedOrders.apply(this, arguments);
    }

    return getUnassignedOrders;
  }()
};
exports.actions = actions;